<template>
  <router-link :class="{ active: isActive(tab) }" :to="route">
    {{ tab.title }}
  </router-link>
</template>

<script>
import { tabsMixin } from '@/mixins/tabs';

// @vuese
// Liniki zakładek
// @group Components
export default {
  mixins: [tabsMixin],
  props: {
    // Zakładka
    tab: {
      type: Object,
      required: true
    }
  },
  computed: {
    route() {
      const tabRoute = this.tab.route;
      return {
        ...tabRoute,
        params: { ...this.$route.params, ...tabRoute.params },
        query: { ...this.$route.query, ...tabRoute.query }
      };
    }
  }
};
</script>
